import { TranslocoHelper } from '@core/helpers/transloco.helper';
import { TableColumn, TableColumnTypeEnum } from '@oranta-mis/ui-library';

export const educationOrderListColumnHeader= (i18n: TranslocoHelper): TableColumn[] =>[
  { type: TableColumnTypeEnum.text, key: 'education', name: i18n.tr('education_programs') },
  {
    type: TableColumnTypeEnum.actions,
    key: 'actions',
    name: i18n.tr('actions'),
    actions: ['pay', 'details', 'cancel'],
  },
];
